import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const DragDrop = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon {...other}>
			<path
				d="M10.99975,6.00075 L14.9995,6.00075 L14.9995,2 L10.99975,2 L10.99975,6.00075 Z M5,6.00075 L8.9995,6.00075 L8.9995,2 L5,2 L5,6.00075 Z M10.99975,12.0005 L14.9995,12.0005 L14.9995,8.0005 L10.99975,8.0005 L10.99975,12.0005 Z M5,12.0005 L8.9995,12.0005 L8.9995,8.0005 L5,8.0005 L5,12.0005 Z M10.99975,18 L14.9995,18 L14.9995,14.00025 L10.99975,14.00025 L10.99975,18 Z M5,18 L8.9995,18 L8.9995,14.00025 L5,14.00025 L5,18 Z"
				id="dragDrop"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

DragDrop.propTypes = {
	color: PropTypes.string,
};

export default DragDrop;
